import { toast } from 'react-toastify';

const REQUIRED_ENV_VARS = {
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
} as const;

export function checkEnvironmentVariables(): boolean {
    let isValid = true;
    const missing: string[] = [];

    Object.entries(REQUIRED_ENV_VARS).forEach(([key, value]) => {
        if (!value) {
            isValid = false;
            missing.push(key);
            console.error(`Missing required environment variable: ${key}`);
        }
    });

    if (!isValid) {
        const errorMessage = `Missing required environment variables: ${missing.join(', ')}`;
        console.error(errorMessage);
        toast.error(errorMessage);
    }

    return isValid;
}

// Export environment variables in a type-safe way
export const ENV = {
    API_URL: REQUIRED_ENV_VARS.REACT_APP_API_URL!,
} as const; 